// extracted by mini-css-extract-plugin
export default {"title":"AnimeCard_title__rADYI","poster":"AnimeCard_poster__d7yea"};